import React, { useState } from 'react';
import { connect } from 'react-redux';
import Toolbar from '../../components/common/Toolbar';
import Integration from '../../components/blocks/Integration';
import IntegrationModal from '../../components/modals/IntegrationModal';
import IntegrationEbayModal from '../../components/modals/IntegrationEbayModal';
import IntegrationGoogleModal from '../../components/modals/IntegrationGoogleModal';
import IntegrationShopifyModal from '../../components/modals/IntegrationShopifyModal';
import { redirectToGoogle, redirectToEbay, redirectToShopifyRetailer } from '../../store/actions/integrations';
import ShopifySetupInstructionsModal from '../../components/modals/ShopifySetupInstructionsModal';

const EBAY = 'ebay';
const GOOGLE = 'google';
const SHOPIFY = 'shopify';
const INTEGRATION = 'integration';
const SHOPIFY_SETUP_INSTRUCTIONS = 'shopifySetupInstructions';

function IntegrationContainer(props) {
  const [modals, setModals] = useState({
    [EBAY]: false,
    [GOOGLE]: false,
    [SHOPIFY]: false,
    [INTEGRATION]: false,
    [SHOPIFY_SETUP_INSTRUCTIONS]: false,
  });

  const openModal = (type) => setModals((modals) => ({ ...modals, [type]: true }));
  const closeModal = (type) => setModals((modals) => ({ ...modals, [type]: false }));

  return (
    <>
      <IntegrationModal open={modals[INTEGRATION]} onClose={() => closeModal(INTEGRATION)} />

      <ShopifySetupInstructionsModal
        open={modals[SHOPIFY_SETUP_INSTRUCTIONS]}
        onClose={() => closeModal(SHOPIFY_SETUP_INSTRUCTIONS)}
        retailerId={props.retailer.id}
      />

      <IntegrationShopifyModal
        open={modals[SHOPIFY]}
        onClose={() => closeModal(SHOPIFY)}
        submit={props.redirectToShopify}
      />

      <IntegrationGoogleModal
        open={modals[GOOGLE]}
        onClose={() => closeModal(GOOGLE)}
        submit={props.redirectToGoogle}
      />

      <IntegrationEbayModal open={modals[EBAY]} onClose={() => closeModal(EBAY)} submit={props.redirectToEbay} />

      <Toolbar name="Integration" />
      <Integration
        onOpen={(type) => (type === SHOPIFY ? openModal(SHOPIFY_SETUP_INSTRUCTIONS) : openModal(INTEGRATION))}
        retailer={props.retailer}
        openShopifyModal={() => openModal(SHOPIFY)}
        openGoogleModal={() => openModal(GOOGLE)}
        openEbayModal={() => openModal(EBAY)}
        isAdmin={props.isSuperAdmin}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  const { data } = state.adminAccountInfo;
  const { user } = state.role;

  const isSuperAdmin = !!user?.is_super_admin;

  return {
    retailer: data,
    isSuperAdmin,
  };
};

const mapDispatchToProps = (dispatch) => ({
  redirectToEbay: (marketplaceId) => dispatch(redirectToEbay(marketplaceId)),
  redirectToShopify: (name) => dispatch(redirectToShopifyRetailer(name)),
  redirectToGoogle: (name) => dispatch(redirectToGoogle(name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationContainer);
